import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import './LegalPage.css';

const TermsOfService: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-900">
      <Navbar />
      
      <div className="legal-page">
        <div className="legal-container">
          {/* Header Section */}
          <div className="legal-header">
            <Link to="/" className="back-button">
              <ArrowLeft size={20} />
              <span>Back to Home</span>
            </Link>
            
            <div className="legal-title-section">
              <h1 className="legal-main-title">Terms And Conditions</h1>
              <p className="legal-subtitle">
                Please read these terms and conditions carefully before using our website.
              </p>
              <div className="legal-last-updated">
                Last updated: July 2025
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div className="legal-content">
            <div className="legal-content-card">
              
              <div className="legal-intro">
                <p>
                  Welcome to <strong>echoesoflunaria.com</strong>. These Terms and Conditions ("Terms") govern your use of our website. By accessing or using this site, you agree to these Terms. If you do not agree, please do not use the site.
                </p>
              </div>

              <div className="legal-section">
                <h2>1. About the Site</h2>
                <p>
                  <strong>echoesoflunaria.com</strong> is a digital platform dedicated to the novel <em>Echoes of Lunaria</em>. Users can access content, create accounts, purchase in-platform currency (vos), and make voluntary donations to support the project.
                </p>
              </div>

              <div className="legal-section">
                <h2>2. User Accounts</h2>
                <ul>
                  <li>You must create an account to access certain features (e.g. reading content, donating, purchasing vos).</li>
                  <li>You are responsible for maintaining the security of your login credentials.</li>
                  <li>We may suspend or terminate accounts involved in misuse, abuse, or fraudulent activity.</li>
                </ul>
              </div>

              <div className="legal-section">
                <h2>3. Intellectual Property</h2>
                <ul>
                  <li>All content on this website—including text, images, logos, and design—is the intellectual property of the creator unless otherwise stated.</li>
                  <li>You may not copy, distribute, modify, or reuse any content without written permission.</li>
                </ul>
              </div>

              <div className="legal-section">
                <h2>4. Donations & Vos Purchases</h2>
                <ul>
                  <li>Donations are completely voluntary and non-refundable.</li>
                  <li>Vos (our virtual currency) is used for unlocking chapters or features and is also non-refundable.</li>
                  <li>All transactions require a registered account.</li>
                  <li>For more, please read the Donation Terms and Vos Terms.</li>
                </ul>
              </div>

              <div className="legal-section">
                <h2>5. User Conduct</h2>
                <p>You agree not to:</p>
                <ul>
                  <li>Violate any applicable laws or regulations</li>
                  <li>Attempt to gain unauthorized access to the platform</li>
                  <li>Use bots, automation, or exploit the platform in any way</li>
                  <li>Post or transmit any harmful, abusive, or offensive content</li>
                </ul>
              </div>

              <div className="legal-section">
                <h2>6. Platform Changes</h2>
                <ul>
                  <li>We reserve the right to change, update, or remove features, content, or services at any time without prior notice.</li>
                </ul>
              </div>

              <div className="legal-section">
                <h2>7. Disclaimers</h2>
                <ul>
                  <li>All content is provided "as-is" without warranties of any kind.</li>
                  <li>We are not liable for any loss, damage, or inconvenience caused by the use of this site.</li>
                </ul>
              </div>

              <div className="legal-section">
                <h2>8. Governing Law</h2>
                <ul>
                  <li>This platform is operated informally. In case of disputes, we encourage resolving issues directly and respectfully by contacting us first.</li>
                </ul>
              </div>

              <div className="legal-section">
                <h2>9. Contact</h2>
                <p>For any concerns, please reach out to:</p>
                <p className="contact-info">📧 echosoflunaria@gmail.com</p>
              </div>

              <div className="legal-footer-note">
                <p>
                  <strong>By continuing to use echoesoflunaria.com, you confirm that you have read and agree to these Terms and Conditions.</strong>
                </p>
              </div>

            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default TermsOfService;